// ------------------------------------
// Constants
// ------------------------------------
export const CUSTOMURLS_PUT_REQUEST = "CUSTOMURLS_PUT_REQUEST";
export const CUSTOMURLS_PUT_REQUEST_SUCCESS = "CUSTOMURLS_PUT_REQUEST_SUCCESS";
export const CUSTOMURLS_PUT_REQUEST_FAILURE = "CUSTOMURLS_PUT_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: CUSTOMURLS_PUT_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: CUSTOMURLS_PUT_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: CUSTOMURLS_PUT_REQUEST_FAILURE,
    error,
  };
}
